import { AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn } from '@angular/forms';

import type { RepeatableSubField } from '../../../interfaces/input.interface';
import { getRegistryCodeValidationRule } from '../../../utils/field-pattern-validation.utils';
import { FormCustomValidators } from '../../../utils/form-custom-validators';

export class RepeatableRowFormFactory {
    private static readonly formCustomValidators = new FormCustomValidators();

    public static createRowsForm(subFields: RepeatableSubField[]): { rowsForm: FormGroup; rowsArray: FormArray<FormGroup> } {
        const rowsArray = new FormArray<FormGroup>([]);

        rowsArray.push(RepeatableRowFormFactory.createRowGroup(subFields));

        return {
            rowsForm: new FormGroup({ rows: rowsArray }),
            rowsArray,
        };
    }

    public static createRowGroup(subFields: RepeatableSubField[]): FormGroup {
        const controls: Record<string, AbstractControl> = {};

        for (const subField of subFields) {
            controls[subField.key] = new FormControl<unknown>(null, RepeatableRowFormFactory.createValidators(subField));
        }

        return new FormGroup(controls);
    }

    public static ensureRowsCount(rowsArray: FormArray<FormGroup>, desiredRows: number, subFields: RepeatableSubField[]): void {
        while (rowsArray.length < desiredRows) {
            rowsArray.push(RepeatableRowFormFactory.createRowGroup(subFields));
        }

        while (rowsArray.length > desiredRows) {
            rowsArray.removeAt(rowsArray.length - 1);
        }

        if (rowsArray.length === 0) {
            rowsArray.push(RepeatableRowFormFactory.createRowGroup(subFields));
        }
    }

    private static createValidators(subField: RepeatableSubField): ValidatorFn[] {
        const explicitPattern = subField.input.validationConfiguration?.pattern;
        const explicitMessage = subField.input.validationConfiguration?.patternMessage;
        const registryRule = getRegistryCodeValidationRule(subField.key, subField.label);
        const pattern = explicitPattern ?? registryRule?.pattern;
        const message = explicitMessage ?? registryRule?.message;

        if (!pattern || !message) {
            return [];
        }

        return [RepeatableRowFormFactory.formCustomValidators.createPatternMessageValidator(pattern, message)];
    }
}
